import { useSurveySubmissionStatus } from '@/modules/onboarding/use-survey-submission-status'

import { ShareSalaryV2 } from '../share/share-salary-v2'
export function InviteSalariesBanner({
  isAuthenticated,
}: {
  isAuthenticated: boolean
}) {
  const { isOnboardingComplete } = useSurveySubmissionStatus({
    isAuthenticated,
  })

  if (!isOnboardingComplete) return null

  return (
    <div
      className={`w-full rounded-lg px-4 md:px-8 py-3 md:py-6 mt-2 flex justify-between items-center 
    bg-blue-90/50 gap-4`}
    >
      <div>
        <p className="text-lg font-semibold text-copy-primary">
          Want to see more salaries?
        </p>
        <p className="text-copy-muted text-sm">
          Share Marit with your friends in medicine and tell them to add their
          anonymous salary. Let’s make this a movement!
        </p>
      </div>
      <ShareSalaryV2 isAuthenticated={isAuthenticated} />
    </div>
  )
}
